var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-element-loading',{attrs:{"is-full-screen":!!!_vm.contain,"background-color":"#FFFFFF","color":"#FDCE48","spinner":"bar-fade-scale"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }